import React from "react";
import Row from "./Row";
import Text from "./Text";

export default function RowText({
  label,
  size = "sm",
  weight = "400",
  value,
  labelStyle,
  textStyle,
  children,
  noColon = false,
  containerStyle,
  useOrderLayout,
  ...props
}) {
  const orderContainerStyle = useOrderLayout ? { flexDirection: "column" } : {};
  const orderLabelStyle = useOrderLayout
    ? { fontSize: "14px", marginBottom: "4px" }
    : {};
  const orderTextStyle = useOrderLayout ? { fontWeight: 500 } : {};

  return (
    <Row
      style={{ ...orderContainerStyle, ...containerStyle }}
      removeMaxWidth={useOrderLayout}
    >
      {label && (
        <Text
          size={size}
          weight={weight}
          color="#4a4e5a"
          style={{ ...orderLabelStyle, ...labelStyle }}
          {...props}
        >
          {label}
        </Text>
      )}
      <Text
        size={size}
        weight={weight}
        color="#25272c"
        style={{ ...orderTextStyle, ...textStyle }}
        {...props}
      >
        {value}
      </Text>
      {children}
    </Row>
  );
}
